import React from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { Col, FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { Button, ButtonBar, Icon } from '../../../../common/components';
import { flow, get } from 'lodash';
import './BrokerSetPasswordForm.scss';
import { connect } from 'react-redux';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import { required, length } from 'redux-form-validators';
const InputGroupAddon = InputGroup.Addon;
const FORM_NAME = 'BrokerSetPassword';

const isRequired = required({ message: 'Password is Required' });
const isLongEnough = length({ min: 8, message: 'Password must be 8 characters or more' });

class BrokerSetPasswordForm extends React.Component {
  componentWillMount() {
    const { broker, dispatch, change } = this.props;
    const primaryContacts = getIncludedResource(
      broker.data,
      broker.included,
      'primary_contacts',
    );
    const primaryContactEmail = get(primaryContacts, '0.attributes.email');
    dispatch(change('meta.email', primaryContactEmail));
  }

  render() {
    const { handleSubmit, submitting, activateBroker } = this.props;
    return (
      <Form onSubmit={handleSubmit(activateBroker)}>
        <h1>Almost there…</h1>
        <p>
          Please set your password below to log into our Admin panel, to start trading
          with us.
        </p>
        <p className="broker-set-password-form-note">
          *Note; once you’ve logged in, you will be able to set up additional users within
          your organisation.
        </p>
        <div className="broker-set-password-form">
          <Field id="email" name="meta.email" component={renderEmailField} />
          <Field
            id="password"
            name="meta.password"
            validate={[isRequired, isLongEnough]}
            component={renderPasswordField}
          />
          <Field
            id="password"
            name="meta.password_confirmation"
            component={renderPasswordField}
            confirm
          />
          <ButtonBar>
            <Button
              id="login-button"
              type="submit"
              className="pull-right"
              bsStyle="primary"
            >
              {submitting ? (
                <i className="fa fa-cog fa-spin" />
              ) : (
                <i className="fa fa-sign-in" />
              )}{' '}
              login
            </Button>
          </ButtonBar>
        </div>
      </Form>
    );
  }
}
const renderEmailField = (field) => {
  const {
    input,
    meta: { touched, error },
  } = field;
  return (
    <FormGroup>
      <Col sm={12}>
        <InputGroup>
          <InputGroupAddon>
            <Icon name="envelope" />
          </InputGroupAddon>
          <FormControl.Static type="email" placeholder="Email address">
            {input.value}
          </FormControl.Static>
        </InputGroup>
      </Col>
      <Col sm={12}>
        {touched && error && <span className="input-error">{error}</span>}
      </Col>
    </FormGroup>
  );
};

const renderPasswordField = (field) => {
  const {
    input,
    confirm,
    meta: { touched, error },
  } = field;
  const placeholder = confirm ? 'Confirm password' : 'Enter password';
  return (
    <FormGroup>
      <Col sm={12}>
        <InputGroup>
          <InputGroupAddon>
            <Icon name="lock" />
          </InputGroupAddon>
          <FormControl {...input} type="password" placeholder={placeholder} />
        </InputGroup>
      </Col>
      <Col sm={12}>
        {touched && error && <span className="input-error">{error}</span>}
      </Col>
    </FormGroup>
  );
};

export default flow([
  reduxForm({
    form: FORM_NAME,
  }),
  connect((state) => ({
    formValues: getFormValues(FORM_NAME)(state),
    broker: state.brochure.broker,
  })),
])(BrokerSetPasswordForm);
